import React from 'react';

const ChatGiveMessage = ({ name }) => (
    <>
        <p className='main-give-message'>Olá {name} seja bem vindo, 
        infelizmente no momento 
        não há operadores disponivels.
        Porem caso preferir deixe sua menagem,
        que iremos responder assim que possiíel</p>
        
        <p className='give-message'>Digite sua mensagem...</p>
    </>
);

export default ChatGiveMessage;